/**
 * The built-in difficulty ladder — the six levels a gym starts with, and what an
 * uncustomised gym falls back to.
 *
 * ONE copy for the client (`constants.js` re-exports it as `DIFFICULTY`) and
 * the Cloud Functions (the challenge board prices an uncustomised gym off this
 * ladder through `getDifficultyConfig(gym, discipline, { fallback: "builtin" })`,
 * so the live preview and the server-written standings agree). The server used
 * to carry a points-only copy; a reweight would have moved the app's numbers and
 * left the challenge board on the old scale.
 *
 * `label` is the Hungarian default — the client translates the six built-in
 * keys through `tDiffLabel`, the e-mails through `ROUTE_LABELS`; a gym's own
 * (custom) level keeps its stored label.
 */
// Route difficulty tiers with associated colors and point values
export const DEFAULT_DIFFICULTY = {
  white:  { label: "Fehér",  points: 1,  color: "#e0e0e0", border: "#bbb",    tc: "#333", order: 0 },
  blue:   { label: "Kék",    points: 2,  color: "#2563eb", border: "#1d4ed8", tc: "#fff", order: 1 },
  yellow: { label: "Sárga",  points: 5,  color: "#eab308", border: "#ca8a04", tc: "#333", order: 2 },
  // One step darker than the rest of the ramp (green-700/800 where the others
  // are 600/700) — deliberately, do NOT "restore" it to #16a34a. These badges
  // carry 7-12px bold text, so they owe 4.5:1, and white on green-600 reaches
  // only 3.30:1. No ink fixes that: white is already the lightest there is, so
  // the fill has to move. Dark ink would clear it (#333 at 3.83, black at
  // 6.37) but would make green the one mid-tone level with dark text, which
  // reads as a light level and breaks the ladder. green-700 keeps white text
  // at 5.02:1 and is still unmistakably green.
  green:  { label: "Zöld",   points: 10, color: "#15803d", border: "#166534", tc: "#fff", order: 3 },
  red:    { label: "Piros",  points: 20, color: "#dc2626", border: "#b91c1c", tc: "#fff", order: 4 },
  black:  { label: "Fekete", points: 40, color: "#1f1f1f", border: "#000",    tc: "#fff", order: 5 },
};
